import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Content, Title, Message, Toggle, Children, ErrorMessage } from './styles';

export type Props = {
  title: string;
  message?: string;
  errorMessage?: string;
  value: boolean;
  onToggle: (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => void;
  children?: React.ReactNode;
  className?: string;
  isDisabledToggle: boolean;
};

const ToggleCard = ({
  title,
  message,
  errorMessage,
  value,
  onToggle,
  children,
  className,
  isDisabledToggle,
}: Props) => {
  const { t } = useStoreTranslation();
  const isError = !isDisabledToggle && !!errorMessage;
  return (
    <div>
      <Container className={className} isError={isError} isDisabled={isDisabledToggle}>
        <Content>
          <div>
            <Title isDisabled={isDisabledToggle}>{title}</Title>
            {message && <Message isDisabled={isDisabledToggle}>{message}</Message>}
          </div>
          <Toggle checked={value || false} onChange={onToggle} disabled={isDisabledToggle} />
        </Content>
        {children && <Children>{children}</Children>}
      </Container>
      {errorMessage && <ErrorMessage>{t(errorMessage)}</ErrorMessage>}
    </div>
  );
};

ToggleCard.defaultProps = {
  isDisabledToggle: false,
};

export default ToggleCard;
